module.exports = __webpack_public_path__ + "img/metrics--avatar.f3c1050a.svg";